<style lang='less' scoped>
@import '../base.less';
</style>
<template>
  <div>
    <!-- SEARCH -->
    <!--    -->
    <Row>
      <Col span='24'>
        <Card>
          <!-- ADDBUTTON -->
          <div class='margin-bottom-15'>
            <Button type='primary' v-has="'payManage/coinExchange/add'" @click='preAdd' icon='md-add'>
              {{ $t('add_button') }}
            </Button>
          </div>
          <!-- DATA -->
          <div>
            <Table :loading='listLoading' :columns='columnsList' :data='tableData' border></Table>
          </div>
          <!-- PAGE -->
          <div class='margin-top-15' style='text-align: center'>
            <Page :total='tableShow.listCount' :current='tableShow.currentPage' :page-size='tableShow.pageSize'
                  @on-change='changePage' @on-page-size-change='changeSize'
                  :page-size-opts='[10,20,30,40,50,100,200,300]' show-elevator show-sizer show-total></Page>
          </div>
        </Card>
      </Col>
    </Row>
    <!-- windowAddEdit -->
    <Modal v-model="windowAdd.show" width="668" :styles="{top: '30px'}" @on-visible-change="windowAddCancel">
      <p slot="header" style="color:#2d8cf0">
        <Icon type="md-alert"></Icon>
        <span>{{ windowAddItem.id ? $t('编辑') : $t('新增') }}</span>
      </p>
      <Form ref="windowAddForm" :rules="windowAddValidate" :model="windowAddItem" :label-width="120"
            label-position="left">
        <FormItem label='币种' prop='currency'>
          <Input v-model='windowAddItem.currency' :placeholder="$t('请输入币种')"></Input>
        </FormItem>
        <FormItem label='买入汇率(充值)' prop='exchange_rate_buy'>
          <Input v-model='windowAddItem.exchange_rate_buy' :placeholder="$t('请输入买入汇率(充值)')"></Input>
        </FormItem>
        <FormItem label='卖出汇率(提现)' prop='exchange_rate_sell'>
          <Input v-model='windowAddItem.exchange_rate_sell' :placeholder="$t('请输入卖出汇率(提现)')"></Input>
        </FormItem>
        <FormItem label='排序' prop='sort'>
          <Input v-model='windowAddItem.sort' :placeholder="$t('请输入排序')"></Input>
        </FormItem>
        <FormItem label='作为平台货币' prop='is_default'>
          <Select v-model='windowAddItem.is_default' style='width:200px'>
            <Option :value="'0'" :key='0'>{{ $t('否') }}</Option>
            <Option :value="'1'" :key='1'>{{ $t('是') }}</Option>
          </Select>
          <Tag color="error" class="margin-left-5">平台货币只能有一种,请勿设置多种,默认货币的买入卖出汇率都要为1</Tag>
        </FormItem>
        <FormItem label='状态' prop='is_lock'>
          <Select v-model='windowAddItem.is_lock' style='width:200px'>
            <Option :value="'0'" :key='0'>{{ $t('正常') }}</Option>
            <Option :value="'1'" :key='1'>{{ $t('锁定') }}</Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="windowAddCancel()" class="margin-right-10">{{ $t('取消') }}</Button>
        <Button type="primary" @click="windowAddSubmit" :loading="windowAdd.loading">{{ $t('确定') }}</Button>
      </div>
    </Modal>
    <!--    -->
  </div>
</template>
<script>
import {
  getList,
  lock,
  add,
  del
} from '@/api/payManage/coinExchange'
import {
  formattingMonth,
  lastMonthDate
} from '@/libs/time'

export default {
  name: 'interface_list',
  data () {
    return {
      timeOptions: {
        shortcuts: [{
          text: '今天',
          value () {
            let a = new Date(new Date(new Date().toLocaleDateString()).getTime())
            let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
            return [a, b]
          }
        },
          {
            text: '昨天',
            value () {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 + 24 * 60 *
                60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '一周',
            value () {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 * 7)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '本月',
            value () {
              return formattingMonth()
            }
          },
          {
            text: '上月',
            value () {
              return lastMonthDate()
            }
          },
        ]
      },
      columnsList: [{
        title: this.$t('币种'),
        key: 'currency',

        minWidth: 120,
        align: 'center'
      }, {
        title: this.$t('买入汇率(充值)'),
        key: 'exchange_rate_buy',

        minWidth: 120,
        align: 'center'
      }, {
        title: this.$t('卖出汇率(提现)'),
        key: 'exchange_rate_sell',

        minWidth: 120,
        align: 'center'
      }, {
        title: this.$t('排序'),
        key: 'sort',

        minWidth: 120,
        align: 'center'
      }, {
        title: this.$t('是否作为平台货币(只能一种)'),
        align: 'center',
        minWidth: 100,

        key: 'is_default',
        render: (h, params) => {
          return h('div', [
            h('span', {
              style: {
                color: params.row.is_default ? '#ed4014' : '#19be6b',
                borderRadius: '11px',
                border: params.row.is_default ? '1px solid #ed4014' : '1px solid #19be6b',
                display: 'block',
                height: '25px',
                width: '70%',
                lineHeight: '25px',
                margin: 'auto'
              },
            }, params.row.is_default ? this.$t('是'): this.$t('否')),
          ])
        }
      }, {
        title: this.$t('是否锁定'),
        align: 'center',
        minWidth: 100,

        key: 'is_lock',
        render: (h, params) => {
          return h('div', [
            h('span', {
              style: {
                color: params.row.is_lock ? '#ed4014' : '#19be6b',
                borderRadius: '11px',
                border: params.row.is_lock ? '1px solid #ed4014' : '1px solid #19be6b',
                display: 'block',
                height: '25px',
                width: '70%',
                lineHeight: '25px',
                margin: 'auto'
              },
            }, params.row.is_lock ? this.$t('锁定') : this.$t('正常')),
          ])
        }
      }, {
        title: this.$t('操作'),
        align: 'center',
        minWidth: 120,
        render: (h, params) => {
          let vm = this
          return h('div', [h('Button', {
            props: {
              type: 'primary'
            },
            style: {
              margin: '0 5px'
            },
            on: {
              'click': () => {
                let vm = this
                vm.windowAddItem.id = params.row.id
                vm.windowAddItem.currency = params.row.currency
                vm.windowAddItem.exchange_rate_buy = params.row.exchange_rate_buy
                vm.windowAddItem.exchange_rate_sell = params.row.exchange_rate_sell
                vm.windowAddItem.sort = params.row.sort
                vm.windowAddItem.is_lock = params.row.is_lock.toString()
                vm.windowAddItem.is_default=params.row.is_default.toString()
                vm.windowAdd.show = true

              }
            }
          }, this.$t('修改')), h('Poptip', {
            props: {
              confirm: true,
              title: this.$t('确定要修改?'),
              transfer: true
            },
            on: {
              'on-ok': () => {

                lock(params.row.id).then(response => {
                  this.$Message.success(response.data.msg)
                  this.getList()
                })
                params.loading = false

              }
            }
          }, [
            h('Button', {
              style: {
                margin: '0 5px'
              },
              props: {
                type: this.$t('info'),
                placement: 'top',
                loading: params.isDeleting
              }
            }, !params.row.is_lock ? this.$t('锁定') : this.$t('解锁'))
          ]), h('Poptip', {
            props: {
              confirm: true,
              title: this.$t('您确定要删除?'),
              transfer: true
            },
            on: {
              'on-ok': () => {

                del(params.row.id).then(response => {
                  this.tableData.splice(params.index, 1)
                  this.$Message.success(response.data.msg)
                })
                params.loading = false

              }
            }
          }, [
            h('Button', {
              style: {
                margin: '0 5px'
              },
              props: {
                type: this.$t('error'),
                placement: 'top',
                loading: params.isDeleting
              }
            }, this.$t('删除'))
          ]),])
        }
      },],
      tableData: [],//用于放LIST数据绑定
      tableShow: { //用于分页
        currentPage: 1,
        pageSize: 10,
        listCount: 0
      },
      searchConf: { searchTime: [], }, // 搜索字段

      buttonShow: { //按钮状态显示
        edit: true,
        del: true,
        changeStatus: true
      },
      listLoading: false, //显示加载中状态
      //弹窗--------------
      windowAdd: { //弹窗
        show: false,
        loading: false,
        index: 0
      },
      windowAddItem: { //弹窗数据绑定
        id: 0
      },
      windowAddValidate: {//窗口校验规则
      },                            //----------------
    }
  },
  created () {
    let vm = this
    vm.getList()
    vm.hasRule('payManage/coinExchange/edit').then(res => {
      vm.buttonShow.edit = res
    })
    vm.hasRule('payManage/coinExchange/del').then(res => {
      vm.buttonShow.del = res
    })
    vm.hasRule('payManage/coinExchange/changeStatus').then(res => {
      vm.buttonShow.changeStatus = res
    })
  },
  methods: {
    preAdd () {
      let vm = this
      vm.windowAddItem.id = 0
      vm.windowAddItem.currency = ''
      vm.windowAddItem.exchange_rate_buy = ''
      vm.windowAddItem.exchange_rate_sell = ''
      vm.windowAddItem.sort = 10
      vm.windowAddItem.is_lock = '0'
      vm.windowAdd.show = true
    },
    changePage (page) {
      this.tableShow.currentPage = page
      this.getList()
    },
    changeSize (size) {
      this.tableShow.pageSize = size
      this.getList()
    },
    search () {
      this.tableShow.currentPage = 1
      this.getList()
    },
    getList () {
      let vm = this
      vm.listLoading = true
      getList({
        page: vm.tableShow.currentPage,
        size: vm.tableShow.pageSize,
        search: vm.searchConf
      }).then(response => {
        vm.tableData = response.data.data.list
        vm.tableShow.listCount = response.data.data.count
        vm.listLoading = false
      })
    },

    timeChange (datetimerange) { //时间修改，自动计算尾部时间
      if (datetimerange[0] !== '' && datetimerange[1] !== '') {
        let patt = /00:00:00/
        this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        if (patt.test(datetimerange[1])) {
          datetimerange[1] = datetimerange[1].replace('00:00:00', '23:59:59')
          this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        }
      } else {
        this.searchConf.searchTime = []
      }
    },
    sortChange: function ({ column, key, order }) {
      //order值可能为asc,desc,normal
      this.searchConf.order = [key, order]
      if (order == 'normal') {
        this.searchConf.order = []
      }
      this.getList()
    },
    windowAddCancel (data) {
      if (!data) {
        this.windowAddItem.id = 0
        this.$refs['windowAddForm'].resetFields()
        this.windowAdd.show = false
        this.windowAdd.loading = false
        this.windowAdd.index = 0
      }
    }, windowAddSubmit () {
      let vm = this
      vm.$refs['windowAddForm'].validate((valid) => {
        if (valid) {
          vm.windowAdd.loading = true

          add(vm.windowAddItem).then(response => {
            vm.$Message.success(response.data.msg)
            vm.getList()
            vm.windowAddCancel()
          }).catch(() => {
            vm.windowAdd.loading = false
          })
        }
      })
    },
  }
}
</script>
